module.exports = __webpack_public_path__ + "img/nodeType3.e49c7edc.svg";